import React, { useEffect, useState } from "react";
import './PrivacyPolicy.css'; // Ensure the CSS is correctly imported
import { useLanguage } from "../../context/LanguageContext/LanguageContext";

const PrivacyPolicy = () => {
  const [privacyPolicySections, setPrivacyPolicySections] = useState([]);
  const { translations, direction, language } = useLanguage();
  const t = translations; // Translation object from context

  useEffect(() => {
    // Define your privacy policy sections with translations
    const policySections = [
      {
        heading: t.introductionHeading, // Use translation
        content: t.introductionContent2, // Use translation
      },
      {
        heading: t.dataCollectionHeading, // Use translation
        content: t.dataCollectionContent, // Use translation
        list: [
          t.personalIdentification, // Use translation
          t.deviceInformation, // Use translation
          t.usageInformation, // Use translation
        ],
      },
      {
        heading: t.dataUsageHeading, // Use translation
        content: t.dataUsageContent, // Use translation
      },
      {
        heading: t.dataProtectionHeading, // Use translation
        content: t.dataProtectionContent, // Use translation
      },
      {
        heading: t.sharingOfDataHeading, // Use translation
        content: t.sharingOfDataContent, // Use translation
      },
      {
        heading: t.thirdPartyServicesHeading, // Use translation
        content: t.thirdPartyServicesContent, // Use translation
      },
      {
        heading: t.yourRightsHeading, // Use translation
        content: t.yourRightsContent, // Use translation
      },
      {
        heading: t.changesToPolicyHeading, // Use translation
        content: t.changesToPolicyContent, // Use translation
      },
    ];

    setPrivacyPolicySections(policySections);
  }, [t]); // Re-run if translations change

  return (
    <div className="privacy-container">
      <h1>{t.privacyPolicyTitle}</h1> {/* Use translation */}
      <p>{t.privacyPolicyIntro}</p> {/* Use translation */}

      <div className="privacy-policy-content">
        {privacyPolicySections.map((section, index) => (
          <div key={index} className="policy-section">
            <h2>{section.heading}</h2>
            <p>{section.content}</p>
            {section.list && (
              <ul>
                {section.list.map((item, idx) => (
                  <li key={idx}>
                    <div className="lineColorBlue"></div>
                    {item}
                  </li>
                ))}
              </ul>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default PrivacyPolicy;
